<template>
  <popper
    :visible-arrow="false"
    :append-to-body="appendToBody"
    trigger="clickToToggle"
    :options="{
      placement: 'bottom-end',
    }"
    :forceShow="popperForceShow"
    @hide="hidePopover"
    @show="showPopover"
    @toggle="togglePopover"
    @documentClick="hidePopover"
    :id="idCalc"
  >
    <div class="popper three-dots-popper-background">
      <ul>
        <template v-for="(item, i) in menuItems">
          <li :key="i" :class="`dropdown-item-${item.variant} ${item.disabled ? 'disabled' : ''}`">
            <div @click="itemAction(item)">
              <Icon
                v-if="item.icon"
                :size="15"
                :icon="item.icon"
                :alt="item.name"
                color="gamma"
                class="dropdown-icon mr-2"
              />
              <Icon
                v-if="item.icon"
                :size="15"
                :icon="item.icon"
                :alt="item.name"
                :color="item.variant === 'danger' || item.variant === 'success' ? 'beta' : 'gamma'"
                class="dropdown-icon-hover mr-2"
              />
              <span class="dropdown-text">{{ item.name }}</span>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <div
      v-if="!$slots.default"
      @focus="handleFocus"
      @focusout="handleFocus"
      tabindex="0"
      slot="reference"
      class="dots"
      :class="isActive ? 'dropdown-active' : ''"
    >
      <Icon :size="20" icon="three-dots" :color="isActive ? 'beta' : 'epsilon'" />
    </div>
    <slot v-if="$slots.default" slot="reference"></slot>
  </popper>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import Icon from "@/components/display/icon/Icon";
import Popper from "@/components/display/Popper";
import { uniqueId } from "lodash-es";

export default {
  name: "DropDown",
  components: { Icon, Popper },
  props: {
    items: {
      type: Array,
      required: true,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    id: String,
  },

  setup(props) {
    const popperForceShow = ref(false);

    const idCalc = computed(() => {
      return props.id || uniqueId("dropdown-");
    });

    const itemAction = (item) => {
      if (item.action) {
        hidePopover();
        item.action();
      }
    };

    const togglePopover = () => {
      popperForceShow.value = !popperForceShow.value;
    };

    const hidePopover = () => {
      popperForceShow.value = false;
    };

    const showPopover = () => {
      popperForceShow.value = true;
    };

    const isActive = ref(false);

    const handleFocus = () => {
      isActive.value = !isActive.value;
    };

    const menuItems = computed(() => {
      return props.items;
    });

    return {
      handleFocus,
      isActive,
      itemAction,
      menuItems,
      idCalc,
      popperForceShow,
      hidePopover,
      togglePopover,
      showPopover,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.dots {
  cursor: pointer;
  padding: 7px 1px;
  width: 22px;
}
.dots:focus {
  outline: none;
}
.popper {
  top: -5px !important;
  left: 0 !important;
  padding: 0;
  text-align: left;
  ul {
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 0;
  }
  ul:hover {
    cursor: pointer;
  }
  li {
    padding-left: 18px;
    padding-right: 18px;
    list-style: none;
    font-size: 0.875rem;
    line-height: 2rem;
  }
  .dropdown-icon {
    display: inline-block;
    position: relative;
    top: 2px;
  }
  li:hover div > .dropdown-icon {
    display: none;
  }
  .dropdown-icon-hover {
    display: none;
  }
  li:hover div > .dropdown-icon-hover {
    display: inline-block;
    position: relative;
    top: 2px;
  }
}

ul {
  li {
    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
      > * {
        pointer-events: none;
      }
    }
  }
}
</style>
